/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Gap_Too_LargeInputs */



/**
* | output |
* | --- |
* | "Frame gap too large" |
*
* @param {Qc_Fix_Gap_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_gap_too_large = /** @type {((inputs?: Qc_Fix_Gap_Too_LargeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Gap_Too_LargeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart d'images trop grand")
	if (locale === "de") return /** @type {LocalizedString} */ ("Frame-Abstand zu groß")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo di fotogrammi troppo grande")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком большой интервал между кадрами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Separación de fotogramas demasiado grande")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧间隔过大")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム間隔が広すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़्रेम अंतराल बहुत बड़ा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo de fotogramas demasiado grande")
	return /** @type {LocalizedString} */ ("Frame gap too large")
});